import { Base } from './Base';

export class HeroFaq extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.formButton = null;
    this.closeButton = null;
    this.formWrapper = null;
    this.init();
  }

  init() {
    this.formWrapper = document.getElementById('faq_form_wrapper'); 
    this.formButton = document.getElementById('faq_form_button');
    this.closeButton = document.getElementById('faq_close_button');

    this.formButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.element.dataset.displayForm = "true";
    });

    this.closeButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.element.dataset.displayForm = "false";
    });
  }
  
}